import React from 'react';
import { useNavigate } from 'react-router-dom'; // 1. Tambahkan import ini

const blogPosts = [
    {
        id: 1,
        title: "Future of AI: Integrating Gemini in Web Apps",
        excerpt: "Kecerdasan buatan bukan lagi masa depan, melainkan masa kini. Integrasi Gemini AI ke dalam aplikasi web...",
        date: "15 Maret 2026",
        author: "Rony Saputra",
        image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=500",
        category: "AI & Tech"
    },
    {
        id: 2,
        title: "Modern UI/UX Trends for Developer Hubs",
        excerpt: "Desain untuk developer membutuhkan keseimbangan antara estetika dan fungsionalitas. Tren tahun 2026...",
        date: "10 Maret 2026",
        author: "Rony Saputra",
        image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=500",
        category: "Design"
    },
    {
        id: 3,
        title: "React JS: Building Nexus Community Hub",
        excerpt: "Membangun Nexus Community Hub dimulai dengan struktur komponen yang modular menggunakan React 18...",
        date: "5 Maret 2026",
        author: "Rony Saputra",
        image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?q=80&w=500",
        category: "Development"
    },
    {
        id: 4,
        title: "Cybersecurity 2026: Melindungi Data Xyrons",
        excerpt: "Ancaman siber semakin cerdas. Pelajari sistem enkripsi terbaru untuk menjaga privasi browsing Anda...",
        date: "1 Maret 2026",
        author: "Admin Xyrons",
        image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=500",
        category: "Security"
    },
    {
        id: 5,
        title: "Evolusi GPU: Mengapa Spek Laptop Gaming Makin Gila",
        excerpt: "Membahas tren hardware terbaru, dari RTX seri terbaru hingga optimalisasi VRAM untuk AI Rendering...",
        date: "28 Feb 2026",
        author: "Rony Saputra",
        image: "https://images.unsplash.com/photo-1587202377425-991ae3a3e47a?q=80&w=500",
        category: "Hardware"
    },
    {
        id: 6,
        title: "Masa Depan Arsitektur Digital & AI",
        excerpt: "Bagaimana AI mengubah cara kita mendesain rumah modern. Rendering cepat dengan bantuan neural network...",
        date: "25 Feb 2026",
        author: "Admin Xyrons",
        image: "https://images.unsplash.com/photo-1600585154340-be6199f7f009?q=80&w=500",
        category: "Architecture"
    },
    {
        id: 7,
        title: "Prompt Engineering: Skill Paling Dicari di 2026",
        excerpt: "Mengapa hasil AI orang lain lebih bagus? Jawabannya ada pada teknik Prompting yang presisi...",
        date: "22 Feb 2026",
        author: "Xyrons Bot",
        image: "https://images.unsplash.com/photo-1675271591211-126ad94e495d?q=80&w=500",
        category: "Education"
    },
    {
        id: 8,
        title: "Membangun Komunitas Digital: Visi Xyrons Hub",
        excerpt: "Lebih dari sekadar website, Xyrons adalah tempat berbagi ide kreatif bagi para tech-enthusiast...",
        date: "20 Feb 2026",
        author: "Rony Saputra",
        image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=500",
        category: "Community"
    },
    {
        id: 9,
        title: "Smart Home Integration: Hidup Lebih Mudah",
        excerpt: "Dari asisten suara hingga optimasi energi otomatis. Bagaimana teknologi Smart Idea diterapkan di rumah...",
        date: "15 Feb 2026",
        author: "Tech Insider",
        image: "https://images.unsplash.com/photo-1558002038-103792e1798e?q=80&w=500",
        category: "Smart Tech"
    },
    {
        id: 10,
        title: "Deep Dive: Memahami Arsitektur Transformer",
        excerpt: "Edukasi teknis mengenai cara kerja LLM seperti Gemini dan GPT di balik layar untuk mahasiswa IT...",
        date: "10 Feb 2026",
        author: "Education Dept",
        image: "https://images.unsplash.com/photo-1507413245164-6160d8298b31?q=80&w=500",
        category: "Tech Theory"
    }
];

export default function Blog() {
    const navigate = useNavigate(); // 2. Inisialisasi navigate

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.title}>LATEST INSIGHTS</h1>
                <p style={styles.subtitle}>Berita dan tutorial terbaru seputar ekosistem AI.</p>
            </header>

            <div style={styles.blogGrid}>
                {blogPosts.map(post => (
                    <article key={post.id} style={styles.postCard}>
                        <div
                            style={{
                                ...styles.postImage,
                                backgroundImage: `url(${post.image})`
                            }}
                        />
                        <div style={styles.postContent}>
                            <span style={styles.categoryBadge}>{post.category}</span>
                            <h2 style={styles.postTitle}>{post.title}</h2>
                            <p style={styles.excerpt}>{post.excerpt}</p>

                            <div style={styles.meta}>
                                <div style={styles.metaLeft}>
                                    <span style={styles.author}>{post.author}</span>
                                    <span style={styles.dot}>•</span>
                                    <span style={styles.date}>{post.date}</span>
                                </div>

                                {/* 3. Tambahkan onClick di sini */}
                                <button
                                    style={styles.readMore}
                                    onClick={() => navigate(`/blog/${post.id}`)}
                                >
                                    Read More
                                </button>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}

// ... styles tetap sama seperti kode kamu sebelumnya ...
const styles = {
    container: { padding: '40px 20px', maxWidth: '1000px', margin: '0 auto', color: '#fff' },
    header: { marginBottom: '50px', textAlign: 'left' },
    title: { fontSize: '32px', color: '#00d2ff', fontWeight: '900', letterSpacing: '-1px' },
    subtitle: { color: '#666', fontSize: '16px', marginTop: '5px' },
    blogGrid: { display: 'flex', flexDirection: 'column', gap: '30px' },
    postCard: {
        display: 'flex',
        background: '#0a0a0a',
        borderRadius: '24px',
        border: '1px solid #1a1a1a',
        overflow: 'hidden',
        flexWrap: 'wrap',
        transition: '0.3s'
    },
    postImage: {
        flex: '1 1 300px',
        minHeight: '250px',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'grayscale(20%) brightness(80%)'
    },
    postContent: { flex: '2 1 400px', padding: '30px', display: 'flex', flexDirection: 'column' },
    categoryBadge: {
        alignSelf: 'flex-start',
        background: '#00d2ff15',
        color: '#00d2ff',
        padding: '5px 12px',
        borderRadius: '8px',
        fontSize: '11px',
        fontWeight: '800',
        marginBottom: '15px'
    },
    postTitle: { fontSize: '22px', margin: '0 0 15px 0', lineHeight: '1.3', fontWeight: '700' },
    excerpt: { color: '#888', fontSize: '15px', lineHeight: '1.6', marginBottom: '25px', flex: 1 },
    meta: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #1a1a1a', paddingTop: '20px' },
    metaLeft: { display: 'flex', gap: '8px', fontSize: '12px', color: '#444', alignItems: 'center' },
    author: { color: '#888' },
    dot: { color: '#333' },
    readMore: {
        background: 'transparent',
        border: 'none',
        color: '#00d2ff',
        fontWeight: 'bold',
        cursor: 'pointer',
        fontSize: '14px',
        padding: '10px' // Tambahkan padding sedikit biar gampang diklik di HP
    }
};